module.exports = __webpack_public_path__ + "images/stickers/taco-sleeping.3aa994dc53c056c6f419.png";